import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentSection, Secondary } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { EventActions, EventCategories, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import styles from "./help-me-choose.module.css";
export var HelpMeChoose = function(blok) {
    var title = blok.title, body = blok.body, buttonLabel = blok.buttonLabel;
    var trackEvent = useAnalytics().trackEvent;
    return /*#__PURE__*/ _jsxs("section", _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(ContentSection, {
                title: title,
                classNames: {
                    title: styles.title
                },
                sectionWrapperClass: styles.contentSectionWrapper,
                children: renderWithResolver(body)
            }),
            /*#__PURE__*/ _jsx(Secondary, {
                classNames: {
                    button: styles.button
                },
                element: "a",
                href: "/help-me-choose/most-important",
                onClick: function() {
                    trackEvent({
                        eventName: "Our commitment - ".concat(buttonLabel),
                        data: {
                            event: {
                                name: EventActions.click,
                                category: EventCategories.button,
                                label: buttonLabel
                            }
                        },
                        type: TrackingEventTypes.ADOBE
                    });
                },
                children: buttonLabel
            })
        ]
    }));
};
